import React from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import CreateListing from './pages/CreateListing';
import ListingDetail from './pages/ListingDetail';
import Dashboard from './pages/Dashboard';
import BulkUpload from './pages/BulkUpload';
import EditListing from './pages/EditListing';
import SellerProfile from './pages/SellerProfile';
import Admin from './pages/Admin';
import './index.css';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { crashed: false }; }
  static getDerivedStateFromError() { return { crashed: true }; }
  render() {
    if (this.state.crashed) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>Something went wrong.</h2>
          <button onClick={() => window.location.href = '/'} style={{ marginTop: '1rem', padding: '.5rem 1.5rem', cursor: 'pointer' }}>
            Go to Home
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="page">
      <div className="empty" style={{ paddingTop: '5rem' }}>
        <div className="empty-icon">🔍</div>
        <h3>Page Not Found</h3>
        <p style={{ marginBottom: '1.5rem' }}>The page you're looking for doesn't exist.</p>
        <button className="btn btn-p" onClick={() => navigate('/')}>Browse Listings</button>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/sell" element={<CreateListing />} />
          <Route path="/listing/:id/edit" element={<EditListing />} />
          <Route path="/listing/:id" element={<ListingDetail />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/bulk-upload" element={<BulkUpload />} />
          <Route path="/seller/:username" element={<SellerProfile />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ErrorBoundary>
  );
}
